import React from 'react';
import '../hero.css';
import { Label, Badge, Video } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../UI/Media/Image';
import { BannerButtons } from 'components/Marketing/Banners';
import { TrustpilotHorizontalReviews } from 'components/Marketing/Reviews/Trustpilot/trustpilotHorizontalReviews';
import clsx from 'clsx';

const TextContainer = ({
  label,
  body,
  placement,
  buttons,
  badges,
  hasTrustpilot,
  children,
}) => {
  const itemsAlign = placement === 'center' ? 'center' : 'start';
  const textAlign = placement === 'center' ? 'center' : 'left';
  const positioning =
    placement === 'center'
      ? 'left-1/4'
      : placement === 'right'
      ? 'left-1/2'
      : 'left-0';
  return (
    <div
      className={clsx(
        'main-wrapper mx-auto',
        'absolute',
        'top-0',
        `left-0 right-0`,
        'h-full'
      )}>
      <div
        className={clsx(
          'absolute',
          'top-0',
          `left-0 md:${positioning}`,
          'w-full md:w-screen/2 lg:w-1/2',
          'h-full',
          'md:items-center',
          'lg:relative',
          'flex'
        )}>
        <div className='h-3/4 lg:h-2/3 flex-1 flex justify-between md:justify-center flex-col'>
          <div
            className={`space-y-8 pt-6 md:pt-0 px-6 flex items-${itemsAlign} text-${textAlign} justify-center flex-col`}>
            {badges ? (
              <div className='flex w-11/12'>
                {badges?.items.map((badge) => (
                  <div className='mr-2'>
                    <Badge {...badge} />
                  </div>
                ))}
              </div>
            ) : null}
            <div className='w-11/12'>
              <Label
                {...label}
                size='6xl'
                weight='medium'
                color={label.color || { classname: 'white' }}
              />
            </div>
            <div className=''>
              <Label
                {...body}
                weight='light'
                family='font-inter'
                size='xl'
                color={{ classname: 'white' }}
              />
            </div>
            {children}
          </div>
          <div className='w-full flex justify-start'>
            <BannerButtons
              buttons={buttons}
              size='lg'
            />
          </div>
          {hasTrustpilot && (
            <div className='absolute inset-x-0'>
              <TrustpilotHorizontalReviews />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const Hero = ({
  label,
  body,
  image,
  video,
  desktopImage,
  buttons,
  badges,
  hasTrustpilot,
  isTextRight,
  shopifyPlaylist,
}) => {
  const textBannerPlacement = isTextRight?.value !== false ? 'right' : 'left';
  return (
    <div
      id='hero-main'
      className='hero-main flex flex-col-reverse md:flex-row w-screen items-center relative'>
      <div className='relative md:hidden h-full w-full'>
        {image && (
          <Image
            objectFit='cover'
            {...image}
            height='100%'
            width='100%'
          />
        )}
        {video && (
          <Video
            {...video}
            height='100%'
            width='100%'
          />
        )}
      </div>
      <div className='hidden absolute border-t border-b md:block h-full w-full'>
        {video && (
          <Video
            {...video}
            height='100%'
            width='100%'
          />
        )}
        {desktopImage && (
          <Image
            objectFit='cover'
            {...desktopImage}
            height='100%'
            width='100%'
          />
        )}
      </div>

      <TextContainer
        placement={textBannerPlacement}
        label={label}
        buttons={buttons}
        badges={badges}
        body={body}
        hasTrustpilot={hasTrustpilot}>
        {shopifyPlaylist ? (
          <iframe
            className={'w-56 sm:w-72'}
            style={{ borderRadius: '12px' }}
            src={`${shopifyPlaylist.path}`}
            width='100%'
            height='80'
            allowFullScreen={false}
            allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
            loading='lazy'></iframe>
        ) : null}
      </TextContainer>
    </div>
  );
};
